// extracted by mini-css-extract-plugin
export default {"messages-page":"Index_messages-page__sivXb","messages-page__info":"Index_messages-page__info__z0w2b"};